// One entry per screen in the reporting dashboard design
// (fifopay-reporting-dashboard-alt.html at the repo root).
//
// Kept as its own file, same as every other module here, so a path is never
// typed as a string literal inside a component.
export default Object.freeze({
  OVERVIEW: "/reporting",
  GENERAL: "/reporting/general",
  SALES: "/reporting/sales",
  OPERATIONS: "/reporting/operations",
  COLLECTIONS: "/reporting/collections",
  CLIENTS: "/reporting/clients",
  PARTNERS: "/reporting/partners",
  SETTINGS: "/reporting/settings",
});
